import { CardContent as MuiCardContent } from "@material-ui/core";
import { styled } from "@material-ui/styles";

const CardContent = styled(MuiCardContent)({
  margin: 20,
});

export default CardContent;
